<!--
  This code is the intellectual property of Bulb Inc. and other software publishers;
  it may not be altered, copied or disclosed without prior written approval.
  Copyright 2026, Bulb Inc. For more information, please email contact@hellobulb.com.
            _
    _            | | _
   | |         _ | || |
   | |__   _  | || || |__
   | '_ \ | | | || || '_ \
  | (_) || |_| || || (_) |
   \___/  \___/ |_| \___/
-->

<div class="canva-format">
  <svg-icon class="cross-icon" role="button" aria-label="Close Dialog"
            aeroTooltip="Close" (click)="closeDialog()" key="times">
  </svg-icon>

  <span class="canva-format-heading" transloco="canva.formatHeading">Canva Export Format</span>

  <p class="canva-format-info" transloco="canva.formatInfo">You can only export one File/Image</p>

  <div class="format-widget-position">
    <!-- Image Option -->
    <div class="format-widget" (click)="selectFormat('png')">
      <div class="icon-container">
        <i class="fa fa-image"></i>
      </div>
      <div class="format-text" transloco="canva.formatImage">Image</div>
    </div>

    <!-- Presentation Option -->
    <div class="format-widget" (click)="selectFormat('pptx')">
      <div class="icon-container">
        <i class="fa fa-file-powerpoint"></i>
      </div>
      <div class="format-text" transloco="canva.formatPresentation">PPT</div>
    </div>
  </div>
</div>
